import { render, staticRenderFns } from "./ImportDataNew.vue?vue&type=template&id=fcb8c4ca&scoped=true"
import script from "./ImportDataNew.vue?vue&type=script&lang=js"
export * from "./ImportDataNew.vue?vue&type=script&lang=js"
import style0 from "./ImportDataNew.vue?vue&type=style&index=0&id=fcb8c4ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb8c4ca",
  null
  
)

export default component.exports